import React from 'react';
export const TestimonialSection = () => {
  return <section className="py-4" data-id="element-202">
      <div className="mb-6" data-id="element-203">
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-204">
          Within two weeks of using the Petssey DNRx, Margaret was amazed to see
          that, in addition to her home's indoor atmosphere, her social life and
          overall well-being had dramatically improved. She no longer worried
          about giving up Mittens or spending a fortune on ineffective
          solutions.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-205">
          After a month, Margaret said all her friends and family told her they
          noticed a huge boost in her energy and enthusiasm for life. She was
          back to her old, vibrant self, eagerly hosting gatherings and spending
          quality time with loved ones. Even Mittens seemed happier!
        </p>
        <a href="https://petssey.com/products/petssey-dnrx" data-id="element-206">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3hkeQKq9oyzxVY19rnWGQ3/ChatGPT_Image_Sep_9%2C_2025%2C_02_28_43_PM.png" alt="Split image showing senior woman peacefully sleeping with her cat and standing happily with her cat in a bright living room" className="w-full md:w-1/2 h-auto object-cover rounded mb-4 md:mb-0 md:mr-4" data-id="element-207" />
          </a>
        <div className="flex flex-col md:flex-row items-center mb-6" data-id="element-208">
          <div className="md:w-1/2" data-id="element-209">
            <p className="text-[22px] text-[#323232] mb-4" data-id="element-210">
              Margaret also shared that her sleep quality improved
              significantly, and during the day, she felt more refreshed and
              energetic, as if she were ten years younger!
            </p>
            <p className="text-[22px] text-[#323232] mb-4" data-id="element-211">
              After Margaret raved to all her friends and family about the
              Petssey DNRx, she immediately ordered 6 more of the life-changing
              devices to give to her other cat-loving friends and neighbours!
            </p>
          </div>
        </div>
        <p className="text-[22px] text-[#323232] italic mb-4" data-id="element-212">
          Margaret said, "Petssey DNRx eliminated the persistent cat dander
          allergens for good and saved my social life and my health. I can
          finally enjoy my retirement to the fullest with Mittens by my side!"
        </p>
      </div>
        <h2 className="text-[24px] font-bold mb-4" data-id="element-213">
          More than 47,000 Australian cat parents last year... but is it really
          worth your attention?
        </h2>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i4ukfEKjHYiYqhzQomZ5My/Untitled_%281000_x_700_px%29_%281250_x_700_px%29.png" alt="Collage of happy customers holding their Petssey DNRx devices" className="w-full h-auto object-cover rounded mb-4" data-id="element-214" />
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-215">
          <a href="https://petssey.com/products/petssey-dnrx" className="text-blue-600 hover:underline" data-id="element-216">
            Petssey DNRx
          </a>{' '}
          was only released recently, but it's already captured the attention of
          thousands of <strong data-id="element-217">Australian families and cat parents</strong>.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-218">
          Once people learned there was a{' '}
          <strong data-id="element-219">safe and affordable solution</strong> for effectively dealing
          with persistent <strong data-id="element-220">cat dander</strong> clogging up their indoor
          air, they were more than eager to give the device a try!
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-221">
          As a result, Petssey DNRx sold far more than the family-owned
          Australian company was prepared for. In fact, last year, <strong data-id="element-222">Petssey DNRx </strong>
          completely sold-out their inventory, twice.
        </p>
        <p className="text-[22px] text-[#323232] mb-4" data-id="element-223">
          Hype around this breakthrough device has been spreading through online
          communities and word-of-mouth from satisfied cat-owning customers.
        </p>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/f3BArJ6QVsHrvJPXXqg6a1/1.png" alt="Social media post from CatFriendlyAudrey showing her with her two cats Luna and Milo while holding the Petssey DNRx device" className="w-full h-auto object-cover rounded mb-4" data-id="element-224" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a7yZrRXUPKmUHRkvv7MyGJ/3.png" alt="Social media post from Eloise_KittyyyMum323 showing her and her husband with their black and white cat and the Petssey DNRx device" className="w-full h-auto object-cover rounded mb-4" data-id="element-225" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kNrAyoxc7UzGMRNKH5AyyG/2.png" alt="Social media post from TeresaGH showing her with two cats sharing her positive experience with Petssey DNRx" className="w-full h-auto object-cover rounded mb-4" data-id="element-226" />
      <p className=" text-center text-[12px] italic text-[#6f6f6f] mb-4" data-id="element-227">
        * The above reviews are ficticious and were instead founded upon
        experiences shared by customers
      </p>
    </section>;
};